export function GetPercentageColor(percentValue: number) {
    const rangedValue = Math.min(100, Math.max(0, percentValue));
    const color = `hsl(${rangedValue}, 100%, 75%)`;
    return color;
}
